import type NonEmptyText from '../non-empty-text';
import { assertIsInstanceOfNonEmptyText } from '../assertions';

interface ITag {
	readonly key: NonEmptyText;
	readonly value: NonEmptyText;
}

export default class Tag implements ITag {
	public get key(): NonEmptyText {
		return this.#key;
	}

	public get value(): NonEmptyText {
		return this.#value;
	}

	#key: NonEmptyText;
	#value: NonEmptyText;
	public constructor({ key, value }: ITag) {
		assertIsInstanceOfNonEmptyText(key);
		this.#key = key;
		assertIsInstanceOfNonEmptyText(value);
		this.#value = value;
	}
}
